import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@core/service/auth.service';

/**
 * Gate a route behind a real auth session. The customer module is publicly viewable,
 * so this guard is applied ONLY to the login-gated create flows (e.g. /customer/book/:id).
 * A guest is sent to /auth/login with a returnUrl so they land back on the gated action
 * after signing in (see LoginComponent's returnUrl handling).
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
};

/**
 * Guard for the Kad Kahwin sub-screens (card / checklist / rsvp). Viewing an existing
 * card stays public — the Majlis hub and any shared link open it with `?cardId=`. The
 * bare path (no `cardId`) is the "create new" intent from the hub, so it is login-gated
 * exactly like /customer/book/:id. Living at the route level (main bundle) means the gate
 * holds even if the lazy invite/card chunk in the browser is stale.
 */
export const inviteCreateGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  // Opening an existing/shared card carries a cardId → public view.
  if (route.queryParamMap.has('cardId')) return true;
  // Bare path = create a new card/checklist → require login.
  if (auth.isAuthenticated()) return true;
  return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
};
